module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section01_01_american-village-e6e2045a68910190d9188f5951bb4669.jpg";